import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const styles = (theme) => ({
  root: {
  },
  field: {
    marginTop: theme.spacing(4),
  },
  secondaryButton: {
    marginTop: theme.spacing(1),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { handleChange, onSubmit, resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { displayInfo, displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    if (resp) {
      displaySuccess('SMS Enabled');
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: submit code');
      dispatchAuthenticationFactorsRefresh();
      clearModalCollection();
    }
  };

  const handleResendCode = async () => {
    handleChange('resend', 'true');
    const resp = await onSubmit();
    if (resp) {
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: resend code');
      displayInfo('Code has been resent.');
    }
  };

  return (
    <Box className={classNames(classes.root, className)}>
      <Header
        title={resource.attr('title')}
      />
      <BodyText text={resource.attr('primaryText')} />
      <MetaControlField className={classes.field} attr={'code'} />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={handleSubmit}
          test={'security-settings-button-sms-register-modal-submit-code'}
        >
          {'Continue'}
        </RoundedButton>
        <TextButton
          className={classes.secondaryButton}
          fullWidth
          onClick={handleResendCode}
        >
          {'I didn\'t receive a code'}
        </TextButton>
      </CenteredActions>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
